import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { buildPath } from '@e-socna/utils';

import { PATH_USER_DEFAULT } from '../../app/constants/paths.constant';
import { GeneratedPasswordDialog } from '../../components/GeneratedPasswordDialog';
import { Wizard } from '../../components/Wizard';
import { FormVariant } from '../enums/variant.enum';

import { useInitialValuesFactory } from './hooks/useInitialValuesFactory.hook';
import { useUserSteps } from './hooks/useSteps.hook';
import { useUserSubmit } from './hooks/useUserSubmit.hook';
import type { CreatedUser } from './hooks/useUserSubmit.hook';

interface Props {
  readonly isInternal: boolean;
}

// Once created, the user's generated password is shown, then their page.
export const UserCreationForm = ({ isInternal }: Readonly<Props>) => {
  const navigate = useNavigate();
  const [created, setCreated] = useState<CreatedUser>();

  const { initialValues } = useInitialValuesFactory(isInternal);
  const { steps, wizardChildren } = useUserSteps();
  const { handleSubmit } = useUserSubmit(setCreated);

  const showCreatedUser = useCallback(() => {
    if (created) {
      void navigate(buildPath(PATH_USER_DEFAULT, { id: created.userId }));
    }
  }, [created, navigate]);

  return (
    <>
      <Wizard
        askMemoBeforeSubmit={false}
        formVariant={FormVariant.Creation}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        showCancelButton={false}
        steps={steps}
      >
        {wizardChildren}
      </Wizard>
      <GeneratedPasswordDialog
        onClose={showCreatedUser}
        password={created?.password ?? null}
        title="Mot de passe de l'utilisateur"
      />
    </>
  );
};
